import React, { useState, useEffect } from 'react';
import {
  FormControl,
  FormItem,
} from '@/features/trade/order/components/order-form-components';
import { Input } from '@/components/ui';
import { bigIntToDecimalStr, validatedDecimalStr } from '@/utils/value-format';
import { useMarketStore } from '@/store/use-markets-store';
import { useFormContext } from 'react-hook-form';
import { useStore } from 'zustand';

interface PriceInputProps {
  symbol: string;
  isSuccess?: boolean;
  onPriceChange: (price: string) => void;
  defaultValue?: string;
}

export const PriceInput: React.FC<PriceInputProps> = ({
  symbol,
  isSuccess,
  onPriceChange,
  defaultValue = '',
}) => {
  const { formState } = useFormContext();

  const [priceInput, setPriceInput] = useState<string>(defaultValue);

  const { markPrice, priceDecimals } = useStore(
    useMarketStore(symbol),
    (state) => ({
      markPrice: state.marketData.markPrice,
      priceDecimals: state.marketSpec.priceDecimals,
    }),
  );

  const handlePriceChange = (value: string) => {
    const validatedValue = validatedDecimalStr(
      value,
      Number(priceDecimals),
      10,
    );
    setPriceInput(validatedValue);
    onPriceChange(validatedValue);
  };

  useEffect(() => {
    if (formState.isSubmitting || !isSuccess) return;
    setPriceInput('');
  }, [formState.isSubmitting, isSuccess]);

  return (
    <FormItem className="h-10">
      <p className="text-vestgrey-200">Limit Price</p>
      <div className="flex flex-1 justify-end">
        <FormControl>
          <Input
            id="price-input"
            className="max-w-[14ch] rounded-none bg-vestgrey-800 font-mono text-base text-foreground transition-colors hover:bg-border"
            value={priceInput}
            onChange={(e) => handlePriceChange(e.target.value)}
            autoComplete="off"
          />
        </FormControl>
        <button
          type="button"
          onClick={() =>
            handlePriceChange(bigIntToDecimalStr(markPrice, priceDecimals))
          }
          className="h-10 bg-vestgrey-800 px-3 font-mono text-sm font-medium uppercase text-primary transition-colors hover:bg-border"
        >
          Mid
        </button>
      </div>
    </FormItem>
  );
};
